import { SettingsDiv } from './Style';
import { Label } from '../Notifications/style/SingleNotificationStyle';
import { useTranslation } from 'react-i18next';
import { campoOcultosType } from './ModalDetailPrint/ModalDetailPrint';
import { useContext, useEffect, useRef } from 'react';
import { UserContext } from '../../context/UserContext';
import { trackEventMatomo } from '../../helpers/matomo';
import { Checkbox, Divider, FormControl, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import sub from 'date-fns/fp/sub';
import { ChecklistReportType } from '../../service/Reports';

type props = {
  camposOcultos: campoOcultosType
  showNotSelected: boolean,
  setShowNotSelected: Function,
  showScoring: boolean,
  setShowScoring: Function,
  showHideFields: boolean,
  setShowHideFields: Function,
  showHeaders: boolean,
  setShowHeaders: Function,
  hideHierarchy: {
    cliente: boolean,
    local: boolean,
    conjunto: boolean,
    unidade: boolean
  },
  setHideHierarchy: Function
  hideEquipe: boolean
  setHideEquipe: Function
  hideUser: boolean
  setHideUser: Function
  hideIdent: boolean
  setHideIdent: Function
  hideAprov: boolean
  setHideAprov: Function
  hideDate: { inicio: boolean, fim: boolean }
  setHideDate: Function,
  hideNAplica: boolean,
  setHideNAplica: Function,
  radioOption: string,
  setRadioOption: Function,
  isPending: boolean,
  chamados: any,
  form: ChecklistReportType,
  formArray: ChecklistReportType[]
};

export default function SettingsDivComp({
  camposOcultos,
  showNotSelected,
  setShowNotSelected,
  showScoring,
  setShowScoring,
  showHideFields,
  setShowHideFields,
  showHeaders,
  setShowHeaders,
  hideHierarchy,
  setHideHierarchy,
  hideEquipe,
  setHideEquipe,
  hideUser,
  setHideUser,
  hideIdent,
  setHideIdent,
  hideAprov,
  setHideAprov,
  hideDate,
  setHideDate,
  hideNAplica,
  setHideNAplica,
  radioOption,
  setRadioOption,
  isPending,
  chamados,
  form,
  formArray
}: props) {
  const { t } = useTranslation('translation');
  const { hierarchyLabel } = useContext(UserContext);

  const checkboxRef = useRef<HTMLInputElement>(null);

  const formularios = chamados?.ticketDetails?.formulario;
  const subitem = chamados?.ticketDetails?.subitens;

  function isInputBlocked(formularios: any, subitem: any) {
    const isFormEmpty = !formularios || formularios.length === 0;
    const isSubitemEmpty = !subitem || Object.keys(subitem).length === 0;

    return isFormEmpty && isSubitemEmpty;
  }

  const verificaNAplica = () => {
    if (form?.itens?.map((ele) => ele?.subitens?.some((ele) => ele?.avaliacao?.some((elem: any) => elem?.valor === -1)))) {
      return true;
    }
    return false;
  };

  return (
    <SettingsDiv>
      {window.location.pathname !== '/preenchimento' && <>
        <FormControlLabel
          control={<Checkbox
            size="small"
            checked={!showHeaders}
            onClick={() => {
              trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
              setShowHeaders(!showHeaders);
            }} />} label={t('checklists.printConfig.Ocultar_cabecalho')} />
        <Divider />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  inputRef={checkboxRef}
                  checked={Object.values(hideHierarchy)?.every(val => val === false)}
                  indeterminate={Object.values(hideHierarchy)?.some(val => val === false)}
                  onChange={() => {
                    const allFalse = Object.values(hideHierarchy).every(val => val === false);
                    const newState = Object.keys(hideHierarchy).reduce((acc, key) => {
                      acc[key as keyof typeof hideHierarchy] = allFalse;
                      return acc;
                    }, {} as typeof hideHierarchy);

                    setHideHierarchy(newState);
                  }} />} label={'Hierarquia'} />
            <Divider />
            <FormGroup>
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  checked={!hideHierarchy.cliente}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setHideHierarchy({ ...hideHierarchy, cliente: !hideHierarchy.cliente });
                  }} />} label={'Ocultar ' + hierarchyLabel.cliente} />
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  checked={!hideHierarchy.local}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setHideHierarchy({ ...hideHierarchy, local: !hideHierarchy.local });
                  }} />} label={'Ocultar ' + hierarchyLabel.local} />
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  checked={!hideHierarchy.conjunto}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setHideHierarchy({ ...hideHierarchy, conjunto: !hideHierarchy.conjunto });
                  }} />} label={'Ocultar ' + hierarchyLabel.conjunto} />
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  checked={!hideHierarchy.unidade}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setHideHierarchy({ ...hideHierarchy, unidade: !hideHierarchy.unidade });
                  }} />} label={'Ocultar ' + hierarchyLabel.unidade} />
            </FormGroup>
          </div>
          <div>
            <Typography variant='subtitle1'>Formulário</Typography>
            <Divider />
            <FormGroup>
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  disabled={(!form?.identificador) || (formArray?.length > 0 && !formArray?.every((ele) => ele?.identificador))}
                  checked={(!hideIdent) || (!form?.identificador) || (formArray?.length > 0 && !formArray?.every((ele) => ele?.identificador))}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setHideIdent(!hideIdent);
                  }} />} label={'Ocultar identificador'} />
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  checked={!hideAprov}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setHideAprov(!hideAprov);
                  }} />} label={'Ocultar aprovação'} />
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  checked={!showScoring}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setShowScoring(!showScoring);
                  }} />} label={t('checklists.printConfig.Ocultar_informacoes')} />
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  disabled={(!form?.camposOcultos) || (formArray?.length > 0 && !formArray?.every((ele) => ele?.camposOcultos))}
                  checked={showHideFields || (!form?.camposOcultos) || (formArray?.length > 0 && !formArray?.every((ele) => ele?.camposOcultos))}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setShowHideFields(!showHideFields);
                  }} />} label={'Exibir campos ocultos'} />
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  checked={!showNotSelected}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setShowNotSelected(!showNotSelected);
                  }} />} label={t('checklists.printConfig.Ocultar_alternativas')} />
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  disabled={verificaNAplica && verificaNAplica()}
                  checked={!hideNAplica || verificaNAplica()}
                  onClick={() => setHideNAplica(!hideNAplica)} />} label={'Ocultar respostas não se aplica'} />
            </FormGroup>
          </div>
        </Stack>
        <Divider />
      </>}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <div>
          <FormControl disabled={isPending}>
            <FormLabel id="demo-radio-buttons-group-label">Exibição de chamados</FormLabel>
            <Divider />
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={radioOption}
              name="radio-buttons-group"
            >
              <FormControlLabel value="hide" control={<Radio onChange={(eve) => setRadioOption(eve.target.value)} />} label="Ocultar informações" />
              <FormControlLabel disabled={isInputBlocked(formularios, subitem)} value="some" control={<Radio onChange={(eve) => setRadioOption(eve.target.value)} />} label="Informações essenciais" />
              <FormControlLabel disabled={
                !formularios?.some((ele: any) => ele.historicoChamado) ||
                !Object?.values(subitem)?.map((ele: any) => ele?.chamados?.some((elem: any) => elem?.historicoChamado))
              } value="all" control={<Radio onChange={(eve) => setRadioOption(eve.target.value)} />} label="Informações completas" />
            </RadioGroup>
          </FormControl>
        </div>
        <div>
          <Typography>{t('Reports.ticketList.dates')}</Typography>
          <Divider />
          <FormGroup>
            <FormControlLabel
              control={<Checkbox
                size="small"
                checked={!hideDate.inicio}
                onClick={() => {
                  trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                  setHideDate({ ...hideDate, inicio: !hideDate.inicio });
                }} />} label={t('Reports.ticketList.hideStart')} />
            <FormControlLabel
              control={<Checkbox
                size="small"
                checked={!hideDate.fim}
                onClick={() => {
                  trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                  setHideDate({ ...hideDate, fim: !hideDate.fim });
                }} />} label={t('Reports.ticketList.hideEnd')} />
          </FormGroup>
        </div>
        {window.location.pathname !== '/preenchimento'
          && <div>
            <Typography variant='subtitle1'>Associação</Typography>
            <Divider />
            <FormGroup>
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  checked={!hideUser}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setHideUser(!hideUser);
                  }} />} label={'Ocultar usuário'} />
              <FormControlLabel
                control={<Checkbox
                  size="small"
                  checked={!hideEquipe}
                  onClick={() => {
                    trackEventMatomo('Relatórios', 'click', 'checkbox', 'seleciona valor');
                    setHideEquipe(!hideEquipe);
                  }} />} label={'Ocultar ' + t('team')} />
            </FormGroup>
          </div>
        }
      </Stack>
    </SettingsDiv>
  );
}
